<template>
    <div id="close">
        <div class="title"> {{title}}</div>
        <div class="img">
            <img src="../assets/close.png" alt="">
            <div class="bottom">
                报名活动已关闭...
            </div>
        </div>
     
    </div>
</template>

<script>
import { getSchool } from '@/utils/auth.js';
export default {
    name: "close",
    data() {
        return {
             title:''
        };
    },
    created(){
        this.title = JSON.parse(getSchool()).project_name;
    },
    methods: {
    },
   
};
</script>

<style lang="scss">
#close {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    background-color: #f6f6f6;
    .title {
        width: 100%;
        color: #2372AD;
        font-size: 0.42rem;
        text-align: center;
        padding-top: 1rem;
        font-family: 'PingFangSC-Semibold';
        font-weight:bold ;
    }
    .img{
        width: 100%;
        margin: 0 auto;
        text-align: center;
         img{
            margin: 0rem auto;
            width: 2.8rem;
            height: 2.8rem;
            margin-top: 2.5rem;
        }
        .bottom{
            width: 100%;
            text-align: center;
            color: #333333;
            font-size: 18px;
            margin: 0.1rem 0
        }
    }
     .footer {
        width: 100%;
        position: fixed;
        font-size: 0.3rem;
        bottom: 0.2rem;
        text-align: center;
        color: #999999;
        a{
             color: #2ab1f3;
            text-decoration: none;
        }
    }
   
}
</style>

